import { createContext, useContext } from "react";
import { AuthContext } from ".";
import { toast } from 'react-toastify';
import { conection } from '../utils/index'
import moment from "moment";


export const AuthContextApi = createContext();


const AuthProvider = ({ children }) => {

    const { states, setters } = useContext(AuthContext);
    const axiosAuth = conection.auth();
    const axiosNoAuth = conection.noAuth();
    const noAuthAndRoot = conection.noAuthAndRoot();


    const login = async (data) => {
        setters.setIsLoading(true)
        try {
            await axiosNoAuth.get('/user/login')
            const response = await axiosNoAuth.post('/user/login', data)
            localStorage.setItem('token', response.data.data.token)
            localStorage.setItem('permisssion', response.data.data.permissao)
            localStorage.setItem('cliente', response.data.data.client)
            localStorage.setItem('usuario', response.data.data.user)
            localStorage.setItem('proprietario', response.data.data.proprietario)
            setters.setSigned(true)
            setters.setIsLoading(false)
            toast.success(response.data.msg)
            return true;
        } catch (err) {
            // console.log(err)
            setters.setIsLoading(false)
            toast.error(err.response.data.msg)
            return false;
        }
    }

    const checkLogin = async () => {
        try {
            await axiosAuth.get('/user/check')
            return true;
        } catch (err) {
            console.log(err)
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                toast.error(err.response.data.msg)
            } else {
                toast.error(err.response.data.msg)
            }
        }
    }

    const forgotPass = async (data) => {
        setters.setIsLoading(true)
        try {
            await axiosNoAuth.post('/user/forgotPassword', data)
            setters.setIsLoading(false)
            return true;
        } catch (err) {
            setters.setIsLoading(false)
            return false;
        }
    }

    const forgotChangePass = async (data) => {
        setters.setIsLoading(true)
        try {
            await axiosNoAuth.post('/user/forgotChangePass', data)
            setters.setIsLoading(false)
            return true;
        } catch (err) {
            setters.setIsLoading(false)
            return false;
        }
    }

    const logout = async () => {
        setters.setIsLoading(true)
        try {
            await axiosAuth.get('/user/logOut')
            setters.setIsLoading(false)
            localStorage.removeItem('token')
            localStorage.removeItem('permisssion')
            localStorage.removeItem('cliente')
            localStorage.removeItem('usuario')
            setters.setSigned(false)
            return true;
        } catch (err) {
            setters.setIsLoading(false)
            return false;
        }
    }


    //#region Recuperação de Senha

    const getRecuperacaoDeSenhaDataSistema = async () => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.get('/dadosSistema/recuperacaoSenha')
            setters.setIsLoading(false)
            setters.setDataEstatisticaRecuperacaoSenha(response.data.data)
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)

                return;
            } else {
                toast.error(err.response.data.msg)
            }
        }
    }

    const getRecuperacaoSenha = async () => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.get(`/userForgot/getWithLimit/${states.limiteRecuperacaoSenha}&${states.offsetRecuperacaoSenha}`)
            setters.setIsLoading(false)
            setters.setDataRecuperacaoSenha(response.data.data)
            if (states.dataRecuperacaoSenha.length === 0) toast.success('Recuperações de senhas carregados com sucesso')
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)

                return;
            } else {
                setters.setLimiteBuscaRecuperacaoSenha(true)
                if (states.offsetRecuperacaoSenha > 0) {
                    setters.setOffsetRecuperacaoSenha(states.offsetRecuperacaoSenha - states.limiteRecuperacaoSenha)
                }
                if (states.offsetRecuperacaoSenha < 0) {
                    setters.setOffsetRecuperacaoSenha(0)
                }
                toast.error(err.response.data.msg)
            }
        }
    }

    const getRecuperacaoSenhaQuery = async (query) => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.get(`/userForgot/${query}/getWithLimit/${states.limiteRecuperacaoSenha}&${states.offsetRecuperacaoSenha}`)
            setters.setIsLoading(false)
            setters.setDataRecuperacaoSenha(response.data.data)
            if (states.dataRecuperacaoSenha.length === 0) toast.success('Recuperações de senhas carregados com sucesso')
            return true;
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)

                return;
            } else {
                setters.setLimiteBuscaRecuperacaoSenha(true)
                if (states.offsetRecuperacaoSenha > 0) {
                    setters.setOffsetRecuperacaoSenha(states.offsetRecuperacaoSenha - states.limiteRecuperacaoSenha)
                }
                if (states.offsetRecuperacaoSenha < 0) {
                    setters.setOffsetRecuperacaoSenha(0)
                }
                toast.error(err.response.data.msg)
            }
            return false;
        }
    }

    //#endregion

    //#region Usuários

    const getUsuariosDataSistema = async () => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.get('/dadosSistema/usuarios')
            setters.setIsLoading(false)
            setters.setDataEstatisticaUsuarios(response.data.data)
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)

                return;
            } else {
                toast.error(err.response.data.msg)
            }
        }
    }

    const getUsuarios = async (query) => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.get(`/user?${query}`)
            setters.setIsLoading(false)
            setters.setDataUsuarios(response.data.data)
            if (states.dataUsuarios.length === 0) toast.success('Usuarios carregados com sucesso')
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)

                return;
            } else {
                setters.setLimiteBuscaUsuarios(true)
                if (states.offsetUsuarios > 0) {
                    setters.setOffsetUsuarios(states.offsetUsuarios - states.limiteUsuarios)
                }
                if (states.offsetUsuarios < 0) {
                    setters.setOffsetUsuarios(0)
                }
                toast.error(err.response.data.msg)
            }
        }
    }

    const getUsuariosQuery = async (query) => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.get(`/user?${query}`)
            setters.setIsLoading(false)
            setters.setDataUsuarios(response.data.data)
            if (states.dataUsuarios.length === 0) toast.success('Usuarios carregados com sucesso')
            return true;
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)

                return;
            } else {
                setters.setLimiteBuscaUsuarios(true)
                if (states.offsetUsuarios > 0) {
                    setters.setOffsetUsuarios(states.offsetUsuarios - states.limiteUsuarios)
                }
                if (states.offsetUsuarios < 0) {
                    setters.setOffsetUsuarios(0)
                }
                toast.error(err.response.data.msg)
            }
            return false;
        }
    }

    const postUsuarios = async (data) => {
        setters.setIsLoading(true)
        try {
            await axiosAuth.post('/user/create', data)
            setters.setIsLoading(false)
            toast.success('Usuário cadastrado com sucesso')
            await getUsuarios()
            return true;
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                toast.error(err.response.data.msg)
                return;
            }
            toast.error(err.response.data.msg)
            return false;
        }
    }

    const putRoleUsuarios = async (data) => {
        setters.setIsLoading(true)
        try {
            await axiosAuth.put(`/user/role/${states.Usuarios.id}`, data)
            setters.setIsLoading(false)
            setters.setUsuarios({})
            toast.success('Usuário editado com sucesso')
            await getUsuarios()
            return true;
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)

                return;
            }
            toast.error(err.response.data.msg)
            return false;
        }
    }

    const blockUnlockUsuarios = async (id, status) => {
        setters.setIsLoading(true)
        try {
            await axiosAuth.put(`/user/blockUnlock/${id}`, { noData: "data" })
            setters.setIsLoading(false)
            setters.setUsuarios({})
            const msg = status ? 'Usuário desbloqueado com sucesso' : 'Usuário bloqueado com sucesso'
            toast.success(msg)
            await getUsuarios()
            return true;
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)

                return;
            }
            toast.error(err.response.data.msg)
            return false;
        }
    }

    const deleteUsuarios = async (id, status) => {
        setters.setIsLoading(true)
        try {
            await axiosAuth.delete(`/user/${id}`)
            setters.setIsLoading(false)
            setters.setUsuarios({})
            toast.success('Usuário deletado com sucesso')
            await getUsuarios()
            return true;
        } catch (err) {
            console.log(err)
            setters.setIsLoading(false)
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)

                return;
            }
            toast.error(err.response.data.msg)
            return false;
        }
    }

    //#endregion

    //#region Logs

    const getLogsDataSistema = async () => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.get('/dadosSistema/logs')
            setters.setIsLoading(false)
            setters.setDataEstatisticaLogs(response.data.data)
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)

                return;
            } else {
                toast.error(err.response.data.msg)
            }
        }
    }

    const getLogsMetricas = async () => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.get('/logs/metricas')
            setters.setIsLoading(false)
            setters.setDataEstatisticaLogs(response.data.data)
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)

                return;
            } else {
                toast.error(err.response.data.msg)
            }
        }
    }

    const getRequestsMetricas = async () => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.get('/requests/metrics')
            setters.setIsLoading(false)
            setters.setDataEstatisticaRequests(response.data.data)
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)

                return;
            } else {
                toast.error(err.response.data.msg)
            }
        }
    }

    const getLogs = async (query) => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.get(`/logs?${query}`)
            setters.setIsLoading(false)
            setters.setDataLogs(response.data.data)
            if (response.data.data.length === 0) toast.success('Logs carregados com sucesso')
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)

                return;
            } else {
                // Reset para página anterior se houver erro
                if (states.page > 0) {
                    setters.setPage(states.page - 1)
                }
                toast.error(err.response.data.msg)
            }
        }
    }

    //#endregion

    //#region dashBoard



    const getDashBoardataSistema = async () => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.get(`/dadosSistema/dashBoard`)
            setters.setIsLoading(false)
            return response.data
        } catch (err) {
            console.log(err)
            setters.setIsLoading(false)
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)

                return { status: false };
            } else {
                toast.error(err.response.data.msg)
                return { status: false };
            }
        }
    }

    //#endregion

    //#region profile



    const profileChangeEmail = async (data) => {
        setters.setIsLoading(true)
        try {
            await axiosAuth.post(`/user/changeemail`, data)
            setters.setIsLoading(false)
            const saveEmail = localStorage.getItem('userEmail')
            if (saveEmail) {
                localStorage.setItem('userEmail', data.email)
            }
            toast.success('Email alterado com sucesso. Confirme a alteração no seu e-mail atual')
            return { status: true };
        } catch (err) {
            console.log(err.response)
            setters.setIsLoading(false)
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)

                return { status: false }
            } else {
                toast.error(err.response.data.msg)
            }
            return { status: false };
        }
    }


    const profileChangeSenha = async (data) => {
        setters.setIsLoading(true)
        try {
            await axiosAuth.post(`/user/changePassword`, data)
            const saveSenha = localStorage.getItem('userPassword')
            if (saveSenha) {
                localStorage.setItem('userPassword', data.novaSenha)
            }
            setters.setIsLoading(false)
            toast.success('Senha alterado com sucesso.')
            return true;
        } catch (err) {
            console.log(err)
            console.log(err)
            setters.setIsLoading(false)
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)

                return;
            } else {
                toast.error(err.response.data.msg)
            }
            return false;
        }
    }

    const profileChangeEmailConfirm = async (token) => {
        setters.setIsLoading(true)
        try {
            await axiosAuth.put(`/user/changeemail/${token}`)
            setters.setIsLoading(false)
            toast.success('Email alterado com sucesso.')
            return true;
        } catch (err) {
            console.log(err.response)
            setters.setIsLoading(false)
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)

                return;
            } else {
                toast.error(err.response.data.msg)
            }
            return false;
        }
    }

    const profileAutenticationEmail = async (token) => {
        setters.setIsLoading(true)
        try {
            await axiosAuth.put(`/user/authEmail/${token}`)
            setters.setIsLoading(false)
            toast.success('Email autenticado com sucesso.')
            return true;
        } catch (err) {
            console.log(err.response)
            setters.setIsLoading(false)
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)

                return;
            } else {
                toast.error(err.response.data.msg)
            }
            return false;
        }
    }

    const profileChangeEmailConfirmCheckLink = async (token) => {
        setters.setIsLoading(true)
        try {
            await axiosAuth.get(`/user/checkLink/${token}`)
            setters.setIsLoading(false)
            return true;
        } catch (err) {
            console.log(err.response)
            setters.setIsLoading(false)
            localStorage.removeItem('token')
            localStorage.removeItem('permisssion')
            localStorage.removeItem('cliente')
            localStorage.removeItem('usuario')
            setters.setSigned(false)
            toast.error(err.response.data.msg)

            return false;
        }
    }



    //#region Contas Recebimento

    const getContasRecebimento = async (query) => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.get(`/empresaPagamento?${query}`)
            setters.setIsLoading(false)
            setters.setDataContasRecebimento(response.data.data)
            return response.data.data;
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                return;
            } else {
                toast.error(err.response.data.msg)
            }
        }
    }

    const postContasRecebimento = async (data) => {
        setters.setIsLoading(true)
        try {
            await axiosAuth.post('/empresaPagamento', data, { headers: { 'Content-Type': 'multipart/form-data' } })
            setters.setIsLoading(false)
            toast.success('Conta de recebimento cadastrada com sucesso')
            return true;
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                return;
            } else {
                toast.error(err.response.data.msg)
                return false;
            }
        }
    }


    const patchContasRecebimento = async (id, data) => {
        setters.setIsLoading(true)
        try {
            await axiosAuth.patch(`/empresaPagamento/${id}`, data, { headers: { 'Content-Type': 'multipart/form-data' } })
            setters.setIsLoading(false)
            toast.success('Conta de recebimento atualizada com sucesso')
            return true;
        } catch (err) {
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                return;
            } else {
                toast.error(err.response.data.msg)
                return false;
            }
        }
    }

    const deleteContasRecebimento = async (id) => {
        setters.setIsLoading(true)
        try {
            await axiosAuth.delete(`/empresaPagamento/${id}`)
            setters.setIsLoading(false)
            toast.success('Conta de recebimento deletada com sucesso')
            return true;
        } catch (err) {
            console.log(err)
            setters.setIsLoading(false)
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                return;
            } else {
                toast.error(err.response.data.msg)
                return false;
            }
        }
    }

    const getServicos = async (query) => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.get(`/servicos?${query}`)
            setters.setIsLoading(false)
            setters.setDataServicos(response.data.data)
            return response.data.data
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                return;
            } else {
                toast.error(err.response.data.msg)
            }
        }
    }

    const postServico = async (data) => {
        setters.setIsLoading(true)
        try {
            await axiosAuth.post('/servicos', data)
            setters.setIsLoading(false)
            toast.success('Serviço cadastrado com sucesso')
            return true;
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                return;
            } else {
                toast.error(err.response.data.msg)
                return false;
            }
        }
    }

    const patchServico = async (id, data) => {
        setters.setIsLoading(true)
        try {
            await axiosAuth.patch(`/servicos/${id}`, data)
            setters.setIsLoading(false)
            toast.success('Serviço atualizado com sucesso')
            return true;
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                return;
            } else {
                toast.error(err.response.data.msg)
                return false;
            }
        }
    }

    const deleteServico = async (id) => {
        setters.setIsLoading(true)
        try {
            await axiosAuth.delete(`/servicos/${id}`)
            setters.setIsLoading(false)
            toast.success('Serviço deletado com sucesso')
            return true;
        } catch (err) {
            console.log(err)
            setters.setIsLoading(false)
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                return;
            } else {
                toast.error(err.response.data.msg)
                return false;
            }
        }
    }

    const getClientes = async (query) => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.get(`/clientes?${query}`)
            setters.setIsLoading(false)
            setters.setDataClientes(response.data.data)
            return response.data.data
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                return;
            } else {
                toast.error(err.response.data.msg)
            }
        }
    }

    const postCliente = async (data) => {
        setters.setIsLoading(true)
        try {
            await axiosAuth.post('/clientes', data)
            setters.setIsLoading(false)
            toast.success('Cliente cadastrado com sucesso')
            return true;
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                return;
            } else {
                toast.error(err.response.data.msg)
                return false;
            }
        }
    }

    const patchCliente = async (id, data) => {
        setters.setIsLoading(true)
        try {
            await axiosAuth.patch(`/clientes/${id}`, data)
            setters.setIsLoading(false)
            toast.success('Cliente atualizado com sucesso')
            return true;
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                return;
            } else {
                toast.error(err.response.data.msg)
                return false;
            }
        }
    }

    const deleteCliente = async (id) => {
        setters.setIsLoading(true)
        try {
            await axiosAuth.delete(`/clientes/${id}`)
            setters.setIsLoading(false)
            toast.success('Cliente deletado com sucesso')
            return true;
        } catch (err) {
            console.log(err)
            setters.setIsLoading(false)
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                return;
            } else {
                toast.error(err.response.data.msg)
                return false;
            }
        }
    }

    const getFaturas = async (query) => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.get(`/faturas?${query}`)
            setters.setIsLoading(false)
            setters.setDataFaturas(response.data.data)
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                return;
            } else {
                toast.error(err.response.data.msg)
            }
        }
    }

    const getFatura = async (id) => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.get(`/faturas/${id}`)
            setters.setIsLoading(false)
            return response.data.data
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                return;
            } else {
                toast.error(err.response.data.msg)
            }
        }
    }

    const getFaturaEdicao = async (id) => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.get(`/faturas/edicao/${id}`)
            setters.setIsLoading(false)
            return response.data.data
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                return;
            } else {
                toast.error(err.response.data.msg)
            }
        }
    }

    const postFatura = async (data) => {
        setters.setIsLoading(true)
        try {
            await axiosAuth.post('/faturas', data)
            setters.setIsLoading(false)
            toast.success('Fatura cadastrada com sucesso')
            return true;
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                return;
            } else {
                toast.error(err.response.data.msg)
                return false;
            }
        }
    }

    const patchFatura = async (data) => {
        setters.setIsLoading(true)
        try {
            await axiosAuth.patch(`/faturas/${data.id}`, data)
            setters.setIsLoading(false)
            toast.success('Fatura atualizada com sucesso')
            return true;
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                return;
            } else {
                toast.error(err.response.data.msg)
                return false;
            }
        }
    }

    const deleteFatura = async (id) => {
        setters.setIsLoading(true)
        try {
            await axiosAuth.delete(`/faturas/${id}`)
            setters.setIsLoading(false)
            toast.success('Fatura excluída com sucesso')
            return true;
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                return;
            } else {
                toast.error(err.response.data.msg)
                return false;
            }
        }
    }

    const extrairDadosCNPJ = async (file) => {
        setters.setIsLoading(true)
        try {
            const formData = new FormData()
            formData.append('cartaoCnpj', file)
            const response = await axiosAuth.post('/clientes/extrator', formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            })
            setters.setIsLoading(false)
            toast.success('Dados extraídos com sucesso')
            return response.data.data
        } catch (err) {
            setters.setIsLoading(false)
            if (err.response && err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                return null;
            } else {
                toast.error(err.response?.data?.msg || 'Erro ao extrair dados do CNPJ')
                return null;
            }
        }
    }


    const downloadFaturaPDF = async (id) => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.get(`/faturas/download/${id}`)
            setters.setIsLoading(false)
            return response.data.data
        } catch (err) {
            console.log(err)
            setters.setIsLoading(false)
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                return false;
            } else {
                toast.error(err.response.data.msg)
                return false;
            }
        }
    }

    const geracaoNovaFatura = async (id) => {
        setters.setIsLoading(true)
        try {
            const response = await axiosAuth.post(`/faturas/geracao/${id}`)
            setters.setIsLoading(false)
            return response.data.data
        } catch (err) {
            console.log(err)
            setters.setIsLoading(false)
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                return false;
            } else {
                toast.error(err.response.data.msg)
                return false;
            }
        }
    }

    const getCep = async (cep) => {
        try {
            const response = await noAuthAndRoot.get(`/get-cep/${cep}`)
            return response.data.data
        } catch (err) {
            if (err.response.status === 403) {
                localStorage.removeItem('token')
                localStorage.removeItem('permisssion')
                localStorage.removeItem('cliente')
                localStorage.removeItem('usuario')
                setters.setSigned(false)
                return false;
            } else {
                toast.error(err.response.data.msg)
                return false;
            }
        }
    }




    return (
        <AuthContextApi.Provider
            value={{
                getFaturaEdicao,
                patchFatura,
                deleteFatura,
                getCep,
                geracaoNovaFatura,
                downloadFaturaPDF,
                getFatura,
                getFaturas,
                postFatura,
                getClientes,
                postCliente,
                patchCliente,
                deleteCliente,
                extrairDadosCNPJ,
                getServicos,
                postServico,
                patchServico,
                deleteServico,
                getContasRecebimento,
                postContasRecebimento,
                patchContasRecebimento,
                deleteContasRecebimento,
                deleteUsuarios,
                profileAutenticationEmail,
                profileChangeEmailConfirmCheckLink,
                profileChangeEmailConfirm,
                profileChangeEmail,
                profileChangeSenha,
                getDashBoardataSistema,
                getLogsDataSistema,
                getLogsMetricas,
                getLogs,
                getRequestsMetricas,
                blockUnlockUsuarios,
                putRoleUsuarios,
                postUsuarios,
                getUsuariosDataSistema,
                getUsuarios,
                getUsuariosQuery,
                getRecuperacaoDeSenhaDataSistema,
                getRecuperacaoSenha,
                getRecuperacaoSenhaQuery,
                login,
                checkLogin,
                forgotPass,
                forgotChangePass,
                logout
            }}>
            {children}
        </AuthContextApi.Provider>
    )
}

export default AuthProvider;
